"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModalHeader = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _core = require("@emotion/core");
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../../theme/utils/useTheme");
var _ActionSeparator = require("../styled/ActionSeparator");
var _Actions = require("../styled/Actions");
var _Header = require("../styled/Header");
var _Title = require("../styled/Title");
var _TitleIcon = require("../styled/TitleIcon");
var _TitleText = require("../styled/TitleText");
var _ModalActionButton = require("./ModalActionButton");
/** @jsxRuntime classic */
/** @jsx jsx */

const ModalHeader = props => {
  const {
    isHeadingMultiline = true,
    title,
    titleIcon,
    titleProps,
    modalActions,
    onCloseRequested,
    className,
    "aria-label": ariaLabel = "Close",
    type = "default",
    xButtonProps
  } = props;
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  const getActionButtonIcon = () => {
    switch (themeMode) {
      case "ursa-light":
        return (0, _core.jsx)(_ursaIcons.CloseIcon, {
          size: 24
        });
      case "lodestar-light":
      default:
        return (0, _core.jsx)(_lodestarIcons.CloseIcon, null);
    }
  };
  return (0, _core.jsx)(_Header.StyledModalHeader, {
    className: className
  }, (0, _core.jsx)(_Title.StyledModalTitle, {
    variant: type === "simple" ? "headerLarge" : "headlineMedium",
    type: type,
    renderAs: "div"
  }, titleIcon && (0, _core.jsx)(_TitleIcon.StyledTitleIcon, null, titleIcon), (0, _core.jsx)(_TitleText.StyledTitleText, (0, _extends2.default)({}, titleProps, {
    type: type,
    isHeadingMultiline: isHeadingMultiline
  }), title)), (0, _core.jsx)(_Actions.StyledModalActions, {
    themeMode: themeMode
  }, modalActions, modalActions && onCloseRequested && (0, _core.jsx)(_ActionSeparator.StyledModalActionSeparator, {
    "data-client-id": "modal-action-separator"
  }), onCloseRequested && (0, _core.jsx)(_ModalActionButton.ModalActionButton, (0, _extends2.default)({
    onClick: onCloseRequested,
    "aria-label": ariaLabel,
    iconBefore: getActionButtonIcon()
  }, xButtonProps))));
};
exports.ModalHeader = ModalHeader;
//# sourceMappingURL=ModalHeader.js.map